import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/actions";
// import { Grid, Cell } from "baseui/layout-grid";
import { useNavigate } from "react-router-dom";
import { AppNavBar, setItemActive } from "baseui/app-nav-bar";
import { ChevronDown, Delete, Upload } from "baseui/icon";
import { StyledLink } from "baseui/link";
import { Link } from "react-router-dom";
// import Logo from "../../assets/hmlogo.webp";

function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);
  const roleId = user.role_id;

  // console.log("roleId", roleId);

  const firstName = useSelector((state) => state.user.first_name);
  const lastName = useSelector((state) => state.user.last_name);
  // const [isOpen, setIsOpen] = React.useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/"); // Redirect to login page
  };

  // Custom Title Component
  const TitleComponent = () => (
    <StyledLink
      $style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
      onClick={() => navigate("/dashboard")}
    >
      <img src="/hmlogo.webp" style={{ height: '24px', padding: '8px'}} alt='holmes motors logo'/>
    </StyledLink>
  );

  const [mainItems, setMainItems] = React.useState(
	roleId === 2
	  ? [
	// 	  ...(user.id === 8
	// 		? [
	// 			{
	// 			  icon: Upload,
	// 			  label: (
	// 				<a
	// 				  href={`https://www.facebook.com/v19.0/dialog/oauth?client_id=${process.env.REACT_APP_FB_APP_ID}&redirect_uri=${encodeURIComponent("https://api.holmesmotors.com/api/facebook/callback")}&scope=pages_show_list,leads_retrieval,pages_read_engagement`}
	// 				  style={{ textDecoration: "none", color: "inherit" }}
	// 				  target="_blank"
	// 				  rel="noopener noreferrer"
	// 				>
	// 				  Reconnect Facebook
	// 				</a>
	// 			  ),
	// 			},
	// 		  ]
	// 		: []),
          {
            icon: Upload,
            label: (
              <Link
                to="/vehicleUpdate"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Vehicle Update
              </Link>
            ),
          },

          {
            icon: Upload,
            label: (
              <Link
                to="/inspections"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Inspections
              </Link>
            ),
          },
		//   {
        //     icon: Upload,
        //     label: (
        //       <Link
        //         // state={{ roleId }} // Sending the user state
        //         to="/serp-results"
        //         style={{ textDecoration: "none", color: "inherit" }}
        //       >
        //         Seo Tracking Dev
        //       </Link>
        //     ),
        //   },
          {
            icon: Upload,
            label: (
              <Link
                to="/vehicleList"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Inventory List
              </Link>
            ),
          },
          {
            icon: Upload,
            label: (
              <Link
                to="/employee-training"
                state={{ roleId }}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Employee Training
              </Link>
            ),
          },
        //   {
        //     icon: Upload,
        //     label: (
        //       <Link
        //         to="/pull-tlo"
        //         style={{ textDecoration: "none", color: "inherit" }}
        //       >
        //         TLO Pull
        //       </Link>
        //     ),
        //   },
        //   {
        //     icon: Upload,
        //     label: (
        //       <Link
        //         to="/chats"
        //         style={{ textDecoration: "none", color: "inherit" }}
        //       >
        //         Chat Conversions
        //       </Link>
        //     ),
        //   },
          {
            icon: ChevronDown,
            label: (
              <Link
                to="/users"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Users
              </Link>
            ),
          },
          // {
          //   icon: ChevronDown,
          //   label: (
          //     <Link
          //       to="/settings/locations"
          //       style={{ textDecoration: "none", color: "inherit" }}
          //     >
          //       Locations
          //     </Link>
          //   ),
          // },
        ]
      : [
          {
            icon: Upload,
            label: (
              <Link
                to="/incomingTable"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Incoming Table
              </Link>
            ),
          },
          {
            icon: Upload,
            label: (
              <Link
                to="/vehicleList"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Inventory List
              </Link>
            ),
          },
          {
            icon: Upload,
            label: (
              <Link
                to="/vehicleUpdate"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Vehicle Update
              </Link>
            ),
          },
          {
            icon: Upload,
            label: (
              <Link
                state={{ roleId }} // Sending the user state
                to="/employee-training"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Employee Training
              </Link>
            ),
          },
        ]
  );

  return (
    <AppNavBar
      title={<TitleComponent />}
      mainItems={mainItems}
      onMainItemSelect={(item) => {
        setMainItems((prev) => setItemActive(prev, item));
      }}
      username={`${firstName} ${lastName}`}
      userName={"person_for_testing"}
      usernameSubtitle="5 Stars"
      userItems={[
        {
          icon: Delete,
          label: "Logout",
          action: "logout",
        },
      ]}
      onUserItemSelect={(item) => {
        if (item.label === "Logout") {
          handleLogout();
        } else {
          console.log(item);
        }
      }}
      overrides={{
        // AppName: {
        //   style: ({}) => ({
        //     textAlign: "center",
        //   }),
        // },
        MainMenuItem: {
          style: ({ $theme, $active }) => ({
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingLeft: "5px",
            paddingRight: "5px", // Individual padding properties
            borderBottomStyle: "none",
            borderBottomWidth: "0px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
            backgroundColor: $active ? "#c1c9c9" : "transparent",
            color: $active ? "#40473f" : $theme.colors.primary,
            ":hover": {
              color: "white",
              backgroundColor: $active ? "#40473f" : "#4a5d65",
            },
          }),
        },
      }}
    />
  );
}

export default NavBar;
